import { Link } from '@ps/web-shared-components';
import React from 'react';

import type { CompetitionDynamicBanner, ImageFetchProps } from '../../model/types';
import BannerImage from '../BannerImage/BannerImage';

import styles from './BasicBanner.scss';

const CompetitionBanner: React.FC<CompetitionDynamicBanner & ImageFetchProps> = ({
  eventType,
  competition,
  image,
  priority
}) => (
  <Link
    className={styles.container}
    alias="sportsCompetition"
    values={{ ...eventType, ...competition }}
  >
    <BannerImage image={image} priority={priority} />
    <h2>{competition.competitionName}</h2>
  </Link>
);

export default CompetitionBanner;
